import { SubscriptionFeatureLimitM } from './../models/organization-subscription/subscription-feature-limit.modal';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpParams } from '@angular/common/http';

//Serives
import { HttpService } from 'src/app/modules/shared/services/http.service';

@Injectable({
    providedIn: 'root'
})
export class OrganizationSubscriptionService {

    private appOrgUrl: string = environment.appOrgUrl;

    constructor(
        private httpService: HttpService
    ){}

    getFeatureSubscriptionInfo(featureType: number, moduleId: number = null): Observable<SubscriptionFeatureLimitM> {
        let params = new HttpParams();
        params = featureType ? params.append('featureType', featureType) : params;
        params = moduleId ? params.append('moduleId', moduleId) : params;

        return this.httpService.getWithParams(`${this.appOrgUrl}UserProfilePermission/SubscriptionInfo/FeatureSubscriptionInfo`, params);
    }
}
